import { deserify, getMediaBasePath, IconWrapper, ImageWrapper, IStyles, pxToRem, pxTovW, ScoreProgressBar, theme } from '@geneo2-web/shared-ui'
import { Box, Divider, Skeleton, Typography, useMediaQuery } from '@mui/material'
import { BannerV2 } from '@protos/learning_management/lms.teacher.apis_pb';
import { useAppSelector } from 'apps/teacher/src/reduxStore/reduxHooks';
const styles: IStyles = {
  root: {
    width: { xs: pxToRem(270), md: pxTovW(550), lg: pxTovW(407) },
    display: 'flex',
    flex: '0 0 auto',
    boxShadow: `0px 0px ${pxToRem(8)} #00000029`,
    p: {
      xs: `${pxToRem(15)} ${pxToRem(13)} ${pxToRem(12)} ${pxToRem(18)}`,
      md: `${pxTovW(21)} ${pxTovW(19)} ${pxTovW(16)} ${pxTovW(25)}`
    },
    borderRadius: { xs: pxToRem(15), md: pxTovW(15) },
    backgroundColor: '#f5f4f4',
    flexDirection: 'column',
    gap: { xs: pxToRem(10), md: pxTovW(15) },
    margin: { xs: pxToRem(5), md: 0 },
    cursor: 'pointer'
  },
  iconImage: {
    width: { xs: pxToRem(25), md: pxTovW(39) },
    height: { xs: pxToRem(25), md: pxTovW(39) },
    borderRadius: '50%',
  },
  iconCard: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  iconBox: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(2), md: pxTovW(3) },
    flexDirection: 'column',
    textAlign: 'center'
  },
  iconInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(3), md: pxTovW(5) },
  },
  rounded: {
    width: { xs: pxToRem(10), md: pxTovW(15) },
    height: { xs: pxToRem(10), md: pxTovW(15) },
  },
  iconRectangle: {
    width: { xs: pxToRem(42), md: pxTovW(49) },
    height: { xs: pxToRem(15), md: pxTovW(17) },
  },
  rectangle: {
    width: { xs: pxToRem(68), md: pxTovW(88) },
    height: { xs: pxToRem(15), md: pxTovW(17) },
  }
}
export const BannerShimmer = () => {
  return (
    <Box sx={styles.root} >
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: { xs: pxToRem(6), md: pxTovW(8) }
      }}>
        <Box sx={{
          display: 'flex',
          gap: { xs: pxToRem(8), md: pxTovW(9) },
        }}>
          <Skeleton
            variant="rounded"
            sx={{
              width: { xs: pxToRem(25), md: pxTovW(39) },
              height: { xs: pxToRem(25), md: pxTovW(39) },
              borderRadius: '50%',
            }}
          />
          <Skeleton
            variant="rectangular"
            sx={{
              marginY: 'auto',
              width: '50%',
              height: { xs: pxToRem(12), md: pxTovW(12) },
              borderRadius: { xs: pxToRem(15) },
            }}
          />
        </Box>
        <Box sx={{
          width: '100%',
        }}>
          <Skeleton
            variant="rectangular"
            sx={{
              width: '100%',
              height: { xs: pxToRem(12), md: pxTovW(27) },
              borderRadius: { xs: pxToRem(15) },
            }}
          />

        </Box>
      </Box>
      <Skeleton
        variant="rectangular"
        sx={{
          width: '60%',
          height: { xs: pxToRem(12), md: pxTovW(17) },
          borderRadius: { xs: pxToRem(15) },
          marginLeft: 'auto'
        }}
      />
      <Divider />
      <Box sx={styles.iconCard}>
        <Box sx={styles.iconBox}>
          <Box sx={styles.iconInfo}>
            <Skeleton
              variant="rounded"
              sx={styles.rounded}
            />
            <Skeleton
              variant="rectangular"
              sx={styles.iconRectangle}
            />
          </Box>
          <Skeleton
            variant="rectangular"
            sx={styles.rectangle}
          />
        </Box>
        <Box sx={styles.iconBox}>
          <Box sx={styles.iconInfo}>
            <Skeleton
              variant="rounded"
              sx={styles.rounded}
            />
            <Skeleton
              variant="rectangular"
              sx={styles.iconRectangle}
            />
          </Box>
          <Skeleton
            variant="rectangular"
            sx={styles.rectangle}
          />
        </Box>

        <Box sx={styles.iconBox}>
          <Box sx={styles.iconInfo}>
            <Skeleton
              variant="rounded"
              sx={styles.rounded}
            />
            <Skeleton
              variant="rectangular"
              sx={styles.iconRectangle}
            />
          </Box>
          <Skeleton
            variant="rectangular"
            sx={styles.rectangle}
          />
        </Box>
      </Box>
    </Box>
  )
}

